import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import SuccinctLayout from "components/SuccinctLayout";
import { enableMapSet } from "immer";
import { PageWithHeaderProps } from "lib/types";
import "../styles/globals.css";

import { LicenseInfo } from "@mui/x-license-pro";

enableMapSet();

LicenseInfo.setLicenseKey(
  "853b9c1baee5e12814b39e90fb22f437Tz0xLEU9MTk3NDA5MDE1Mzg4MCxTPXBybyxMTT1wZXJwZXR1YWwsS1Y9Mg=="
);

const App = ({ Component, pageProps }: PageWithHeaderProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <SuccinctLayout header={Component.header}>
        <Component {...pageProps} />
      </SuccinctLayout>
    </LocalizationProvider>
  );
};

export default App;
